import api from './api';
import { downloadAnexoPost } from './apiAnexo';

export interface MonitoramentoSubcontracacaoResult {
    contratoNumero: string,
    fornecedorNumero: string,
    fornecedorCnpj: string,
    fornecedorNome: string,
    fornecedorNomeResumido: string,
    contratoObjetoResumido: string,
    contatoStatus: string,
    diretoriaSigla: string,
    areaSigla: string,
    departamentoSigla: string,
    gestorNome: string,
    fiscalNome: string,
    administradorNome: string,
    isRespondida: string,
    dataConsulta?: Date,
    dataConsultaFormatada: string,
    dataResposta?: Date,
    dataRespostaFormatada: string,
}

export interface MonitoramentoSubcontracacaoFilter {
    diretoriaIds: string[],
    areasIds: string[],
    departamentosIds: string[],
    contratos: string[],
}

export const findAll = (filtros: MonitoramentoSubcontracacaoFilter) => {
    return api.post<MonitoramentoSubcontracacaoResult[]>(`relatorioMonitoramentoSubcontracacao/findAll`, filtros, { disableNotification: 'true', });
}

export const exportToExcel = async (filtros: MonitoramentoSubcontracacaoFilter) => {
    const url = '/api/relatorioMonitoramentoSubcontracacao/exportToExcel';
    await downloadAnexoPost('RelatorioMonitoramentoSubcontratacao.xlsx', url, filtros);
  }